import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import { useRenumerationModal } from '../context/RenumerationModalContext';

const RenumerationMovementsView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useRenumerationModal();

  return (
    <div>
      <div className="form-group">
        <label className="form-label d-flex w-100 justify-content-between">
          <span className="d-flex align-items-start">
            {t('HowDoYouWantToAssignTheNe')} <MandatoryField />{' '}
          </span>
        </label>

        <div className="row">
          <div className="col-md-4">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input"
                id="automatic"
                checked
                onChange={() => {}}
              />
              <label className="custom-control-label" htmlFor="automatic">
                {t('AutomaticBySttok')}
              </label>
            </div>
          </div>

          <div className="col-md-4">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input"
                id="manual"
                checked={false}
                onChange={() => {}}
                disabled
              />
              <label className="custom-control-label" htmlFor="manual">
                {t('ManualByPartners')}
              </label>
            </div>
          </div>

          <div className="col-md-4">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input"
                id="manual-1"
                checked={false}
                onChange={() => {}}
                disabled
              />
              <label className="custom-control-label" htmlFor="manual-1">
                {t('ManualBySections')}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenumerationMovementsView;
